import logos from './assets/logos';

export default {
    AL: {logo: logos.AL},
    EP: {logo: logos.EP},
    ET: {logo: logos.ET},
    FX: {logo: logos.FX},
    HA: {logo: logos.HA},
    SX: {logo: logos.SX},
    ZA: {logo: logos.ZA},
    ZD: {logo: logos.ZD},
    ZE: {logo: logos.ZE},
    ZI: {logo: logos.ZI},
    ZL: {logo: logos.ZL},
    ZR: {logo: logos.ZR},
    ZT: {logo: logos.ZT},
    ZU: {logo: logos.ZU},
    unknown: {logo: logos.unknown},
};



// WEBPACK FOOTER //
// ./src/app/modules/cars/cars-suppliers.js